var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 18,
    viewBox: "0 0 116 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 0.5 16.6582)",
    fill: "#E43625"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 0.5 2.51758)",
    fill: "#E43625"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 14.625 16.6582)",
    fill: "#E43625"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 14.625 2.51758)",
    fill: "#E43625"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 28.7461 16.6582)",
    fill: "#E43625"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 28.7461 2.51758)",
    fill: "#E43625"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 42.8711 16.6582)",
    fill: "#E43625"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 42.8711 2.51758)",
    fill: "#E43625"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 56.9922 16.6582)",
    fill: "#E43625"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 56.9922 2.51758)",
    fill: "#E43625"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 71.1133 16.6582)",
    fill: "#E43625"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 99.3594 16.6582)",
    fill: "#E43625"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 71.1133 2.51758)",
    fill: "#E43625"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 99.3594 2.51758)",
    fill: "#E43625"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 85.2383 16.6582)",
    fill: "#E43625"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 113.484 16.6582)",
    fill: "#E43625"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 85.2383 2.51758)",
    fill: "#E43625"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.00877,
    cy: 1.01,
    rx: 1.00877,
    ry: 1.01,
    transform: "matrix(1 8.74228e-08 8.74228e-08 -1 113.484 2.51758)",
    fill: "#E43625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDots);
export default __webpack_public_path__ + "static/media/cardDots.dcf0e7543a38661f3eec1f070f2404cd.svg";
export { ForwardRef as ReactComponent };